const HEADING_ELEMS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'strong', 'span'];

export { HEADING_ELEMS };
